/**
 * DriftContext — persistent state for drift detection. Dumb storage
 * only: loads from localStorage on construct, exposes getters/setters,
 * persists on save(). All actual drift logic (stationary/cruising
 * classification, context-tag formatting) lives in DriftDetector service.
 *
 * The context survives page reloads so the [STATIONARY:Nmin] tag keeps
 * counting if the user refreshes mid-ride.
 */
const STORAGE_KEY_LAST_TS = 'gps-last-update-ts';
const STORAGE_KEY_LAST_LAT = 'gps-last-lat';
const STORAGE_KEY_LAST_LON = 'gps-last-lon';
const STORAGE_KEY_STATIONARY_SINCE = 'gps-stationary-since';
export class DriftContext {
    constructor() {
        this._lastTs = 0;
        this._lastLat = NaN;
        this._lastLon = NaN;
        this._stationarySince = 0;
        this._load();
    }
    get lastTs() {
        return this._lastTs;
    }
    get lastLat() {
        return this._lastLat;
    }
    get lastLon() {
        return this._lastLon;
    }
    get stationarySince() {
        return this._stationarySince;
    }
    get hasPriorFix() {
        return this._lastTs > 0 && !isNaN(this._lastLat) && !isNaN(this._lastLon);
    }
    /** Update the recorded state and persist to localStorage */
    update(lat, lon, ts, stationarySince) {
        this._lastLat = lat;
        this._lastLon = lon;
        this._lastTs = ts;
        this._stationarySince = stationarySince;
        this._persist();
    }
    /** Hard reset — used when user explicitly starts a new ride */
    reset() {
        this._lastTs = 0;
        this._lastLat = NaN;
        this._lastLon = NaN;
        this._stationarySince = 0;
        try {
            localStorage.removeItem(STORAGE_KEY_LAST_TS);
            localStorage.removeItem(STORAGE_KEY_LAST_LAT);
            localStorage.removeItem(STORAGE_KEY_LAST_LON);
            localStorage.removeItem(STORAGE_KEY_STATIONARY_SINCE);
        }
        catch { }
    }
    _load() {
        try {
            this._lastTs = parseInt(localStorage.getItem(STORAGE_KEY_LAST_TS) || '0', 10);
            this._lastLat = parseFloat(localStorage.getItem(STORAGE_KEY_LAST_LAT) || 'NaN');
            this._lastLon = parseFloat(localStorage.getItem(STORAGE_KEY_LAST_LON) || 'NaN');
            this._stationarySince = parseInt(localStorage.getItem(STORAGE_KEY_STATIONARY_SINCE) || '0', 10);
        }
        catch { }
    }
    _persist() {
        try {
            localStorage.setItem(STORAGE_KEY_LAST_TS, String(this._lastTs));
            localStorage.setItem(STORAGE_KEY_LAST_LAT, String(this._lastLat));
            localStorage.setItem(STORAGE_KEY_LAST_LON, String(this._lastLon));
            localStorage.setItem(STORAGE_KEY_STATIONARY_SINCE, String(this._stationarySince));
        }
        catch { }
    }
}
//# sourceMappingURL=DriftContext.js.map